import { useMutation } from '@tanstack/react-query';

import { updateProjectConnection } from '@/features/projects/project-details/api/update-project-connection';

export const useUpdateProjectConnection = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: () => void;
}) => {
  return useMutation({
    mutationFn: updateProjectConnection,
    onSuccess,
    onError,
  });
};
